import { DecimalPipe } from '@angular/common';
import { MatSort, MatPaginator } from '@angular/material';
import { ObservableMedia } from '@angular/flex-layout';
import { first } from 'rxjs/operators/first';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { format, isBefore, isDate } from 'date-fns';
import { DataTableSource } from '../../classes/DataTableSource/datatablesource';
import { ApplicationService } from '../../services/application/application.service';
import { AuthService } from '../../services/authentication/auth.service';
import { DialogService } from '../../services/dialogs/dialogs.service';
import { DownloadService, DownloadFormat, HttpMethod } from '../../services/download/download.service';
import { ErrorService } from '../../services/error/error.service';
import { SplashService } from '../../services/splash/splash.service';
import { UserService } from '../../services/user/user.service';
import { SchoolYearPipe } from '../../pipes/schoolyear.pipe';
import { TitleCasePipe } from '../../pipes/titlecase.pipe';
import { Tag, TagTypes } from '../ui/tags/tags.component';
var ManageAdoptionsComponent = /** @class */ (function () {
    function ManageAdoptionsComponent(appService, authService, decimalPipe, dialogService, downloadService, errorService, mediaChange, schoolYearPipe, splashService, titleCasePipe, userService) {
        this.appService = appService;
        this.authService = authService;
        this.decimalPipe = decimalPipe;
        this.dialogService = dialogService;
        this.downloadService = downloadService;
        this.errorService = errorService;
        this.mediaChange = mediaChange;
        this.schoolYearPipe = schoolYearPipe;
        this.splashService = splashService;
        this.titleCasePipe = titleCasePipe;
        this.userService = userService;
        this._subrelease = new Subject();
        this.AllHeaders = ['RequestNumber', /*'Prefix',*/ 'Code', 'Name', 'Requestor', 'DateRequested', 'Status', 'Colleges', 'Actions'];
        this.TagTypes = TagTypes;
    }
    ManageAdoptionsComponent.prototype.ngOnInit = function () {
        var self = this;
        self.AdoptionsData = new DataTableSource([], self.paginator, self.sorter, self.SortAdoptionRequests.bind(self));
        self.Adoptions = null;
        self.AvailableColleges = null;
        self.NoData = false;
        self.PartialViewReady = false;
        self.SmallDisplay = false;
        self.TagOptions = null;
        self.User = null;
        self.SmallDisplay = self.mediaChange.isActive('xs') || self.mediaChange.isActive('sm');
        self.mediaChange
            .asObservable()
            .pipe(takeUntil(self._subrelease))
            .subscribe(function (media) {
            self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
            self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
            self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
        });
        // Get the first non-null UserInfo object so we can begin setting up the component
        self.userService.UserSubject.pipe(takeUntil(self._subrelease), first(function (user) { return user && !!user.AuthToken; })).subscribe(function (user) {
            self.User = user;
            // Set up constant monitoring of the user object, to catch AuthToken updates.
            self.userService.UserSubject.pipe(takeUntil(self._subrelease)).subscribe(function (_user) {
                self.User = _user;
            });
            // Load static data for use in the compoment.
            var adoptionsObs = self.appService.GetAllAdoptionRequests(self.User.AuthToken, self.User.CurrentRole);
            var collegesObs = self.appService.GetAllColleges(self.User.AuthToken);
            combineLatest(adoptionsObs, collegesObs, function (adoptions, colleges) {
                return {
                    Adoptions: adoptions,
                    AvailableColleges: colleges,
                };
            })
                .pipe(takeUntil(self._subrelease))
                .subscribe(function (packet) {
                self.Adoptions = packet.Adoptions;
                self.AvailableColleges = packet.AvailableColleges;
                self.TagOptions = self.AvailableColleges.map(function (c) { return new Tag(c.CollegeName, c.CollegeID, c.Active); });
                self.UpdateAdoptions(packet.Adoptions);
                // Ready for component use.
                self.PartialViewReady = true;
            }, function (error) {
                self.errorService.HandleServiceError(error);
            });
        });
    };
    ManageAdoptionsComponent.prototype.ngOnDestroy = function () {
        this._subrelease.next();
        this._subrelease.complete();
    };
    // #region Approve Request Method
    ManageAdoptionsComponent.prototype.ApproveRequest = function (crs) {
        var self = this;
        if (!crs) {
            return;
        }
        var colleges = (crs.Colleges || []).map(function (x) { return x.CollegeName; }).join(', ');
        // Get the user confirmation before proceeding.
        var message = "You are about to approve the following course adoption request:<br /><br />\n        <strong>Course Code: </strong>" + crs.Code + "<br />\n        <strong>Course Name/Title: </strong>" + crs.Name + "<br />\n        <strong>Grad Requirement: </strong>" + crs.GradRequirementName + "<br />\n        <strong>Credits: </strong>" + self.decimalPipe.transform(crs.HSCredit, '1.1-1') + "<br />\n        <strong>Proposed Use: </strong>" + (crs.ProposedUseID === 0 ? 'Standard' : 'Other (' + crs.ProposedUseDescription + ')') + "<br />\n        <strong>School Year: </strong>" + crs.SchoolYear + "<br />\n        <strong>Requestor: </strong>" + self.titleCasePipe.transform(crs.RequestedByFirstName) + " " + self.titleCasePipe.transform(crs.RequestedByLastName) + "<br />\n        <strong>School: </strong>" + crs.SchoolName + "<br />\n        <strong>College(s): </strong>" + (colleges || '') + "<br />\n        <strong>Date Requested: </strong>" + format(crs.DateRequested, 'M/D/YYYY h:mm A') + "<br /><br />\n        Once this course adoption request is approved, you will need to add the relevant college course prefix " +
            "and code (ex: PHY 2049C) in the \"Manage Courses\" tool in order for DELTA to recognize the college " +
            ("course associated with this adoption request (" + crs.Code + "). Are you sure you wish to approve this course adoption request?");
        self.dialogService
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: message,
            OKText: "Yes - Approve Adoption",
            CancelText: 'No - CANCEL',
        })
            .subscribe(function (success) {
            if (success === true) {
                // Approve adoption request
                self.splashService
                    .DisplaySplash({ TitleText: 'Please Wait', MessageText: 'Approving Course Adoption Request...' })
                    .subscribe(function () {
                    self.appService
                        .ApproveAdoptionRequest(self.User.AuthToken, self.User.CurrentRole, crs.AdoptionRequestID)
                        .subscribe(function (reqs) {
                        self.splashService.CloseSplash();
                        // Snackbar success
                        self.splashService.SnackbarSuccess('Course Adoption Request Approved Successfully.');
                        // Update the list of requests
                        self.UpdateAdoptions(reqs);
                    }, function (error) {
                        self.errorService.HandleServiceError(error);
                    });
                });
            }
        });
    };
    // #endregion
    // #region Deny Request Method
    ManageAdoptionsComponent.prototype.DenyRequest = function (crs) {
        var self = this;
        if (!crs) {
            return;
        }
        var colleges = (crs.Colleges || []).map(function (x) { return x.CollegeName; }).join(', ');
        // Get the user confirmation before proceeding.
        var message = "You are about to <strong>deny</strong> the following course adoption request:<br /><br />\n        <strong>Course Code: </strong>" + crs.Code + "<br />\n        <strong>Course Name/Title: </strong>" + crs.Name + "<br />\n        <strong>Grad Requirement: </strong>" + crs.GradRequirementName + "<br />\n        <strong>Credits: </strong>" + self.decimalPipe.transform(crs.HSCredit, '1.1-1') + "<br />\n        <strong>Proposed Use: </strong>" + (crs.ProposedUseID === 0 ? 'Standard' : 'Other (' + crs.ProposedUseDescription + ')') + "<br />\n        <strong>School Year: </strong>" + crs.SchoolYear + "<br />\n        <strong>Requestor: </strong>" + self.titleCasePipe.transform(crs.RequestedByFirstName) + " " + self.titleCasePipe.transform(crs.RequestedByLastName) + "<br />\n        <strong>School: </strong>" + crs.SchoolName + "<br />\n        <strong>College(s): </strong>" + (colleges || '') + "<br />\n        <strong>Date Requested: </strong>" + format(crs.DateRequested, 'M/D/YYYY h:mm A') + "<br /><br />\n        Are you sure you wish to deny this course adoption request?";
        self.dialogService
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: message,
            OKText: "Yes - Deny Adoption",
            CancelText: 'No - CANCEL',
        })
            .subscribe(function (success) {
            if (success === true) {
                // Deny adoption request
                self.splashService
                    .DisplaySplash({ TitleText: 'Please Wait', MessageText: 'Denying Course Adoption Request...' })
                    .subscribe(function () {
                    self.appService
                        .DenyAdoptionRequest(self.User.AuthToken, self.User.CurrentRole, crs.AdoptionRequestID)
                        .subscribe(function (reqs) {
                        self.splashService.CloseSplash();
                        // Snackbar success
                        self.splashService.SnackbarSuccess('Course Adoption Request Denied Successfully.');
                        // Update the list of requests
                        self.UpdateAdoptions(reqs);
                    }, function (error) {
                        self.errorService.HandleServiceError(error);
                    });
                });
            }
        });
    };
    // #endregion
    // #region Download Adoption Requests Spreadsheet Method
    ManageAdoptionsComponent.prototype.DownloadAdoptionRequestsSpreadsheet = function () {
        var self = this;
        // Set splash
        self.splashService
            .DisplaySplash({ TitleText: 'Please wait', MessageText: 'Downloading Adoption Requests Spreadsheet...' })
            .pipe(takeUntil(self._subrelease))
            .subscribe(function () {
            self.downloadService
                .RetrieveDownload(HttpMethod.GET, "Api/Services/Excel/GetCourseAdoptionRequestsSpreadsheet", {
                AuthToken: self.User.AuthToken || '',
                CurrentRole: self.User.CurrentRole || '',
                Attachment: true,
            }, DownloadFormat.Excel)
                .pipe(takeUntil(self._subrelease))
                .subscribe(function (success) {
                // Drop the splash?
                self.splashService.CloseSplash();
            }, function (error) {
                self.errorService.HandleServiceError(error);
            });
        });
    };
    // #endregion
    // #region Show Adoption Request Info Method
    ManageAdoptionsComponent.prototype.ShowAdoptionRequestInfo = function (crs) {
        var self = this;
        var colleges = (crs.Colleges || []).map(function (x) { return x.CollegeName; }).join(', ');
        var msg = "<strong>Course Code: </strong>" + crs.Code + "<br />\n        <strong>Course Name/Title: </strong>" + crs.Name + "<br />\n        <strong>Grad Requirement: </strong>" + crs.GradRequirementName + "<br />\n        <strong>Credits: </strong>" + self.decimalPipe.transform(crs.HSCredit, '1.1-1') + "<br />\n        <strong>Proposed Use: </strong>" + (crs.ProposedUseID === 0 ? 'Standard' : 'Other (' + crs.ProposedUseDescription + ')') + "<br />\n        <strong>School Year: </strong>" + self.schoolYearPipe.transform(crs.SchoolYear) + "<br />\n        <strong>Requestor: </strong>" + self.titleCasePipe.transform(crs.RequestedByFirstName) + " " + self.titleCasePipe.transform(crs.RequestedByLastName) + "<br />\n        <strong>School: </strong>" + crs.SchoolName + "<br />\n        <strong>College(s): </strong>" + (colleges || '') + "<br />\n        <strong>Date Requested: </strong>" + format(crs.DateRequested, 'M/D/YYYY h:mm A') + "<br />\n        <strong>Request Status: </strong>" + (crs.Approved == null ? 'Pending' : crs.Approved === true ? 'Approved' : 'Denied') + "<br />\n        ";
        if (crs.Approved != null) {
            msg += "<br /><strong>Reviewer: </strong>" + self.titleCasePipe.transform(crs.ReviewedByFirstName) + " " + self.titleCasePipe.transform(crs.ReviewedByLastName) + "<br />\n            <strong>Date Reviewed: </strong>" + format(crs.DateReviewed, 'M/D/YYYY h:mm A');
        }
        // Pop up a dialog.
        self.dialogService
            .OpenMessageBoxDialog({
            TitleText: 'Adoption Request Info',
            MessageText: msg,
            OKText: 'Done',
            height: '500px',
            width: '900px',
        })
            .subscribe();
    };
    // #endregion
    // #region Sort Adoption Requests Method
    ManageAdoptionsComponent.prototype.SortAdoptionRequests = function (First, Second) {
        var self = this;
        var PropA;
        var PropB;
        switch (self.sorter.active) {
            case 'LastName':
                _a = [First.RequestedByLastName, Second.RequestedByLastName], PropA = _a[0], PropB = _a[1];
                break;
            case 'FirstName':
                _b = [First.RequestedByFirstName, Second.RequestedByFirstName], PropA = _b[0], PropB = _b[1];
                break;
            case 'Code':
                _c = [First.Code, Second.Code], PropA = _c[0], PropB = _c[1];
                break;
            case 'DateRequested':
                _d = [First.DateRequested, Second.DateRequested], PropA = _d[0], PropB = _d[1];
                break;
            case 'Status':
                _e = [
                    First.Approved == null ? 'P' : First.Approved === true ? 'A' : 'D',
                    Second.Approved == null ? 'P' : Second.Approved === true ? 'A' : 'D',
                ], PropA = _e[0], PropB = _e[1];
                break;
        }
        if (isDate(PropA) || isDate(PropB)) {
            var baseSort = 0;
            if (isDate(PropA) && !isDate(PropB)) {
                baseSort = 1;
            }
            else if (isDate(PropB) && !isDate(PropA)) {
                baseSort = -1;
            }
            else if (isBefore(PropA, PropB)) {
                baseSort = -1;
            }
            else if (isBefore(PropB, PropA)) {
                baseSort = 1;
            }
            return baseSort * (self.sorter.direction === 'asc' ? 1 : -1);
        }
        else {
            var ValueA = PropA != null && PropA !== '' ? (isNaN(+PropA) ? PropA : +PropA) : PropA;
            var ValueB = PropB != null && PropB !== '' ? (isNaN(+PropB) ? PropB : +PropB) : PropB;
            return (ValueA < ValueB ? -1 : 1) * (self.sorter.direction === 'asc' ? 1 : -1);
        }
        var _a, _b, _c, _d, _e;
    };
    // #endregion
    // #region Update Adoptions Method
    ManageAdoptionsComponent.prototype.UpdateAdoptions = function (requests) {
        var self = this;
        self.Adoptions = requests;
        if (!self.Adoptions || !self.Adoptions.length) {
            self.NoData = true;
            // Put in a fake record to trip the display message
            self.AdoptionsData.Update([{}]);
        }
        else {
            self.NoData = false;
            self.AdoptionsData.Update(self.Adoptions);
        }
        self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
        self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
    };
    return ManageAdoptionsComponent;
}());
export { ManageAdoptionsComponent };
// #region Custom Classes
// #endregion



// WEBPACK FOOTER //
// ./src/app/manageadoptions/manageadoptions.component.ts.pre-build-optimizer.js